import { createApiActionType, createActionType } from 'app/store/utils';

const apiType = createApiActionType('materialize');
const type = createActionType('materialize');

export const TOGGLE_MATERIALIZATION_DIALOG = type('ToggleMaterializationDialog');
export const TABLE_MATERIALIZATION = apiType('TableMaterialization');
